 
import { useState } from "react";
import { Button } from "reactstrap";
import { FiMessageCircle } from "react-icons/fi";

import "./FloatingContactButton.css";
import CourseEnquiryModal from "./CourseEnquiryModal";

function FloatingContactButton({
    buttonText = "Contact Us",
    courseName = "",
}) {

    const [isOpen, setIsOpen] = useState(false);

    const toggleModal = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <>
            {/* =========================================
                FLOATING CONTACT BUTTON
            ========================================= */}

            <div className="floating-contact-wrapper">

                <Button
                    type="button"
                    className="floating-contact-button"
                    onClick={toggleModal}
                    aria-label={buttonText}
                >

                    <span className="floating-contact-icon">
                        <FiMessageCircle />
                    </span>

                    <span className="floating-contact-text">
                        {buttonText}
                    </span>

                </Button>

            </div>


            {/* =========================================
                ENQUIRY MODAL
            ========================================= */}

            <CourseEnquiryModal
                isOpen={isOpen}
                toggle={toggleModal}
                courseName={courseName}
            />

        </>
    );
}

export default FloatingContactButton; 
 
 